/**
 * Validates redirect_uri for OAuth post-login redirect.
 * Only allows redirects to the API origin or explicitly allowed origins.
 */
export const isAllowedRedirectUri = (redirectUri: string | null): boolean => {
  if (!redirectUri || typeof redirectUri !== 'string') {
    return false;
  }

  try {
    const url = new URL(redirectUri);

    // Disallow dangerous protocols
    if (!['http:', 'https:'].includes(url.protocol)) {
      return false;
    }

    const allowedOrigins = getAllowedRedirectOrigins();
    const targetOrigin = url.origin;

    return allowedOrigins.some((allowed) => targetOrigin === allowed);
  } catch {
    return false;
  }
};

const getAllowedRedirectOrigins = (): string[] => {
  const origins: string[] = [];

  // API base URL origin (e.g. https://api.cleancode.test)
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  if (apiBaseUrl) {
    try {
      const apiUrl = new URL(apiBaseUrl);
      origins.push(apiUrl.origin);
    } catch {
      // Invalid API URL, skip
    }
  }

  // Optional: additional allowed origins (comma-separated)
  const extraOrigins = process.env.REACT_APP_OAUTH_ALLOWED_REDIRECT_ORIGINS;
  if (extraOrigins) {
    extraOrigins
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean)
      .forEach((origin) => {
        try {
          const url = new URL(origin);
          origins.push(url.origin);
        } catch {
          // Invalid origins are skipped
        }
      });
  }

  return [...new Set(origins)];
};
